import { jsx as _jsx } from "react/jsx-runtime";
import { IconHeader } from '../../Components/IconHeader';
import scss from './IconSmallArrow.module.scss';
import { useAppSelector } from 'features';
export const IconSmallArrow = ({ isUp, className = '' }) => {
    const theme = useAppSelector(state => state.theme.selectedTheme);
    const dark = theme === 'dark' ? scss.dark : '';
    return (_jsx("div", Object.assign({ className: scss.iconWrapper }, { children: _jsx(IconHeader, { className: `${isUp ? scss.arrowUp : scss.arrowDown} ${className} ${dark}`, iconId: "arrow-up-chevron" }) })));
};
